import React from 'react';
import PricingCardContainer from '../../../Componant/Ecommerce/PricingCard';

const PricingCard = () => {
  return (
    <div className='page-body'>
      <PricingCardContainer />
    </div>
  );
};

export default PricingCard;
